// smoothScroll.js
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import ScrollSmoother from "gsap/ScrollSmoother";

gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

let smoother = null;

/**
 * Initialise ScrollSmoother + ScrollTrigger
 */
export function initSmoothScroll() {
  // Nettoie avant de relancer (au cas où)
  destroySmoothScroll();

  // Crée une nouvelle instance
  smoother = ScrollSmoother.create({
    wrapper: "#smooth-wrapper",   // ton wrapper
    content: "#smooth-content",   // ton contenu
    smooth: 1.2,                  // valeur de smooth
    effects: true,                // active les data-speed / data-lag
  });

    smoother.scrollTo(0, true); // true = smooth

  console.log("✅ ScrollSmoother initialisé");
}

/**
 * Détruit toutes les instances ScrollTrigger & ScrollSmoother
 */
export function destroySmoothScroll() {
  if (smoother) {
    smoother.kill();
    smoother = null;
  }
  ScrollTrigger.getAll().forEach(trigger => trigger.kill());
  console.log("♻️ ScrollSmoother et ScrollTriggers détruits");
}

/**
 * Réinitialise tout (détruit + réinit après un court délai)
 */
export function resetSmoothScroll() {
  destroySmoothScroll();
  setTimeout(() => {
    initSmoothScroll();
  }, 50); // petit délai pour laisser le DOM se mettre à jour
}